(function($) {
  const rlxStep1 = $('#rlx-step-1');
  const rlxStep2 = $('#rlx-step-2');
  const rlxStep3 = $('#rlx-step-3');
  const rlxStep4 = $('#rlx-step-4');
  const rlxStep5 = $('#rlx-step-5');
  const rlxStep6 = $('#rlx-step-6');
  const rlxFormStep1 = $('#rlx-appointment-form-1');
  const rlxFormStep2 = $('#rlx-appointment-form-2');
  const rlxFormStep3 = $('#rlx-appointment-form-3');
  const rlxFormStep4 = $('#rlx-appointment-form-4');
  const rlxFormStep5 = $('#rlx-appointment-form-5');
  const formData = { data1: null, data2: null, data3: null, data4: null, data5: null };
  let accessToken = null;
  let currentDate = new Date(); // Initialize currentDate
  let submitted = false;

  const config = {
    timezone: 'Europe/London',
    herokuUrl: 'https://shielded-savannah-12590-fab98dd2bc6c.herokuapp.com/api/proxy',
    apiUrls: {
      slots: 'https://developer.setmore.com/api/v1/bookingapi/slots',
      customerCreate: 'https://developer.setmore.com/api/v1/bookingapi/customer/create',
      appointmentCreate: 'https://developer.setmore.com/api/v1/bookingapi/appointment/create'
    }
  };

  const purposeLabel = {
    "s1c07732356f55ae0d4655ec70130e11712cf7382": "Discover the Rolex collections",
    "sc837b3ed41696195fe9e1518f889e8f14378b1e9": "Bring or collect your watch for servicing",
    "d40d3cd0-1888-4936-8e14-adcf78af34c7":       "Bring your Rolex watch for selling or trading",
    "ad1cf6c5-8648-4f8b-abac-321dcc639336":       "Discover the collections"
  };

  const purposeCategory = (key) => {
    switch (key) {
      case "s1c07732356f55ae0d4655ec70130e11712cf7382":
      case "ad1cf6c5-8648-4f8b-abac-321dcc639336":
        return "collection discovery";
      case "sc837b3ed41696195fe9e1518f889e8f14378b1e9":
        return "watch servicing";
      case "d40d3cd0-1888-4936-8e14-adcf78af34c7":
        return "watch trading";
      default:
        return "unknown purpose";
    }
  };

  const purposeDurationMin = (key) =>
    key === "sc837b3ed41696195fe9e1518f889e8f14378b1e9" ? 30 : 60;

  const resetPrevStepButton = (step, buttonText) => {
    step.find('.rlx-next-step span').html(buttonText);  // Set custom button text
    step.find('.rlx-next-step').prop('disabled', false).removeClass('disabled');  // Enable button
  };

  const resetRadioButtons = (step) => {
    step.find('input[type="radio"]').attr('data-resetting', 'true').prop('checked', false);
    setTimeout(() => {
      step.find('input[type="radio"]').removeAttr('data-resetting');  // Remove attribute after a slight delay
    }, 100);  // Allow time for the change event to process
  };

  // Setup CSRF token for AJAX requests
  $.ajaxSetup({
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
  });

  const debounce = (func, delay) => {
    let debounceTimer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  // Show error function to handle slot fetching errors
  const showError = (message, step) => {
    step.find('.error-message').text('Critical Error: ' + message).removeClass('hidden');
    step.find('form').addClass('form-error');
    step.find('.rlx-next-step').prop('disabled', true); // Disable the button if there's an error
  };

  if ($.validator) {
    $.validator.addMethod('phoneUK', function(phone_number, element) {
      return this.optional(element) || phone_number.length > 9 &&
        phone_number.match(/^(\(?(0|\+44)[1-9]{1}\d{1,4}?\)?\s?\d{3,4}\s?\d{3,4})$/);
    }, 'Please specify a valid UK phone number');

    $.validator.addMethod('timeslotAvailable', function(value, element) {
      const timeslotSelected = $('#timeslots .rlx-timeslot input[type="radio"]:checked').val();
      return !!timeslotSelected;
    }, "You need to select a timeslot.");

    const getFormData = (formId) => {
      const form = document.getElementById(formId);
      if (!form) {
        console.error('Form not found with id:', formId);
        return null;
      }
      return new FormData(form);
    };

    const validateForm = (form, rules, messages) => {
      return form.validate({
        rules: rules,
        messages: messages,
        errorElement: 'div',
        errorPlacement: (error, element) => {
          error.addClass('invalid-feedback');
          $(element.parent()).append(error);
        },
        highlight: (element) => {
          $(element).addClass('is-invalid').removeClass('is-valid');
        },
        unhighlight: (element) => {
          $(element).addClass('is-valid').removeClass('is-invalid');
        }
      });
    };

    const setupStep = (form, rules, messages, nextStep) => {
      const validator = validateForm(form, rules, messages);
      // Unbind any existing delegated change handler on the form for radio buttons
      form.off('change', 'input[type="radio"]');

      // Delegate the change event to the form, targeting all radio buttons within
      form.on('change', 'input[type="radio"]', debounce(function (event) {
        if ($(this).attr('data-resetting') === 'true') return;  // Ignore if triggered by reset

        if (form.valid()) {
          const currentStep = form.closest('.rlx-form-step');
          const formDataResult = getFormData(form.attr('id'));
          currentStep.find('.rlx-next-step span').html('Moving to next step…');
          currentStep.find('.rlx-next-step').prop('disabled', true).addClass('disabled');
          formData[`data${nextStep - 1}`] = formDataResult;
          // console.log(formData);
          if (!formData[`data${nextStep - 1}`]) return;
          setTimeout(() => {
            currentStep.hide();
            $(`#rlx-step-${nextStep}`).show();
            window[`initStep${nextStep}`]();
          }, 300);
        }
      }, 300));
    };

    const formatDateToString = (date) => {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const fetchAccessToken = async () => {
      try {
        const response = await $.ajax({
          url: config.herokuUrl,
          type: 'POST',
          contentType: 'application/json'
        });
        accessToken = response.data.token.access_token;
        return accessToken;
      } catch (error) {
        console.error('Error fetching access token:', error);
      }
    };

    const refreshAccessToken = (callback) => {
      fetchAccessToken().then(token => {
        if (typeof callback === 'function') {
          callback(token);
        }
      });
    };

    const getWeekDates = (baseDate) => {
      const start = new Date(baseDate);
      start.setDate(baseDate.getDate() - baseDate.getDay() + 1);
      const dates = [];
      for (let i = 0; i < 6; i++) {
        const nextDay = new Date(start);
        nextDay.setDate(start.getDate() + i);
        dates.push({
          fullDate: nextDay,
          displayDate: formatDateToString(nextDay),
          dayOfWeek: nextDay.toLocaleString('en-GB', { weekday: 'short' }),
          dayOfMonth: nextDay.getDate(),
          isPast: nextDay < new Date(new Date().setHours(0, 0, 0, 0))
        });
      }
      return dates;
    };

    const showLoader = () => {
      $('#loader').removeClass('hidden');
    };

    const hideLoader = () => {
      $('#loader').addClass('hidden');
    };

    // const preloadSlots = (dates, currentDate, callback) => {
    //   showLoader();
    //   const $weekdaysRow = $('#weekdays .row').empty();
    //   const slotsData = {};
    //   const fragment = $(document.createDocumentFragment());
    //   dates.forEach((dateInfo) => {
    //     const dayDiv = $('<div>').addClass('rlx-date col-xs-4');
    //     const innerDiv = $('<div>').addClass('rlx-date-inside');
    //     const daySpan = $('<span>').text(dateInfo.dayOfWeek);
    //     const monthSpan = $('<span>').text(dateInfo.dayOfMonth);
    //     innerDiv.append(daySpan, monthSpan);
    //     dayDiv.attr('data-current-date', dateInfo.displayDate);
    //     dayDiv.append(innerDiv);
    //     if (dateInfo.isPast) {
    //       dayDiv.addClass('disabled');
    //     } else {
    //       dayDiv.on('click', () => {
    //         showLoader();
    //         setTimeout(() => {
    //           displaySlots(dateInfo.displayDate, slotsData);
    //         }, 300);
    //       });
    //     }
    //     fragment.append(dayDiv);
    //     if (!dateInfo.isPast) {
    //       fetchSlotsForDate(dateInfo.displayDate, slotsData);
    //     }
    //   });
    //   $weekdaysRow.append(fragment);
    //   setTimeout(() => {
    //     hideLoader();
    //     if (callback && typeof callback === 'function') {
    //       callback(slotsData);
    //     }
    //   }, 300);
    // };

    const preloadSlots = (dates, currentDate, callback) => {
      showLoader();
      const $weekdaysRow = $('#weekdays .row').empty();
      const slotsData = {};
      const fragment = $(document.createDocumentFragment());

      dates.forEach((dateInfo) => {

        // --- Create REAL button instead of div ---
        const dayBtn = $('<button>')
          .attr('type', 'button')
          .addClass('rlx-date col-xs-4')
          .attr('data-current-date', dateInfo.displayDate);

        const innerDiv = $('<div>').addClass('rlx-date-inside');
        const daySpan = $('<span>').text(dateInfo.dayOfWeek);
        const monthSpan = $('<span>').text(dateInfo.dayOfMonth);

        innerDiv.append(daySpan, monthSpan);
        dayBtn.append(innerDiv);

        // Disable past dates
        if (dateInfo.isPast) {
          dayBtn.addClass('disabled').prop('disabled', true);
        } else {
          // Click handler
          dayBtn.on('click', () => {
            showLoader();
            setTimeout(() => {
              displaySlots(dateInfo.displayDate, slotsData);
            }, 300);
          });

          // Preload available slots
          fetchSlotsForDate(dateInfo.displayDate, slotsData);
        }

        fragment.append(dayBtn);
      });

      $weekdaysRow.append(fragment);

      setTimeout(() => {
        hideLoader();
        if (typeof callback === 'function') callback(slotsData);
      }, 300);
    };

    // Fetch timeslots function modification to handle error and mark form as invalid
    const fetchSlotsForDate = (date, slotsData) => {
      if (!accessToken) {
        console.log('No access token found, cannot preload slots.');
        return;
      }
      $.ajax({
        url: config.apiUrls.slots,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accessToken
        },
        data: JSON.stringify({
          staff_key: formData.data3.get('appointment-location'),
          service_key: formData.data1.get('appointment-purpose'),
          selected_date: date,
          off_hours: false,
          double_booking: false,
          slot_limit: 30,
          timezone: config.timezone
        }),
        success: (response) => {
          setTimeout(() => {
            if (response.response && response.data.slots.length > 0) {
              slotsData[date] = response.data.slots;
            } else {
              slotsData[date] = ["No available slots."];
              showError('No available slots. Please select another date.', $('#rlx-step-4'));
            }
            hideLoader();
          }, 300);
        },
        error: () => {
          setTimeout(() => {
            slotsData[date] = ["Error fetching slots."];
            hideLoader();
            showError('Unable to fetch slots. Please try again later.', $('#rlx-step-4'));
          }, 300);
        }
      });
    };

    const convertTimeTo24HourFormat = (time12h) => {
      const [time, modifier] = time12h.split(' ');
      let [hours, minutes] = time.split(':');
      if (hours === '12') {
        hours = '00';
      }
      if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
      }
      return `${hours}:${minutes}`;
    };

    const displaySlots = (date, slotsData) => {
      if (date instanceof Date) {
        date = formatDateToString(date);
      }

      if (typeof date !== 'string') {
        console.error('Invalid date format:', date);
        return;
      }

      const today = new Date();
      const currentTime = today.getHours() * 60 + today.getMinutes(); 
      let validTimeslots = false; // Track if there are any valid timeslots

      setTimeout(() => {
        const $timeslotsRow = $('#timeslots .row').empty();
        if (slotsData[date]) {
          // console.log(slotsData);

          slotsData[date].forEach(timeslot => {
            const [time, modifier] = timeslot.split(' ');
            let [hours, minutes] = time.split(':');

            hours = parseInt(hours, 10);

            if (modifier === 'PM' && hours !== 12) hours += 12;
            if (modifier === 'AM' && hours === 12) hours = 0;

            const paddedHours = String(hours).padStart(2, '0');
            const paddedMinutes = String(minutes).padStart(2, '0');

            const slotTimeInMinutes = hours * 60 + parseInt(minutes, 10);

            if (date === formatDateToString(today) && slotTimeInMinutes <= currentTime) {
              return;
            }

            validTimeslots = true;

            const formattedDate = date.split('/').reverse().join('-');  
            const formattedTime = `${paddedHours}:${paddedMinutes}`;    
            const formattedDateTime = `${formattedDate}T${formattedTime}Z`;

            // --- Create real button instead of radio input ---
            const btn = $(`
              <button type="button" class="rlx-timeslot-btn col-xs-4" data-value="${formattedDateTime}">
                <div class="rlx-timeslot-btn-inside">
                  ${timeslot.replace('AM', 'am').replace('PM', 'pm')}
                </div>
              </button>
            `);

            btn.on('click', function () {

              // Remove selection from others
              $('.rlx-timeslot-btn').removeClass('selected');

              // Set new selected
              $(this).addClass('selected');

              // Update hidden form field (validator expects a "timeslot" value)
              $('#hidden-timeslot-input').val($(this).data('value')).trigger('change');
            });

            $timeslotsRow.append(btn);
            $('.timeslot-container').show();
          });

          if (!validTimeslots) {
            // No valid timeslots for the selected day
            $timeslotsRow.append('<p class="error-message">No available timeslots for this day.</p>');
            $('.timeslot-container').show();
            disableDateElement(date);
          }

          $('input[type="radio"][name="timeslot"]').change(function () {
            $('input[type="radio"][name="timeslot"]').parent().removeClass('checked');
            if ($(this).is(':checked')) {
              $(this).parent().addClass('checked');
            }
          });
          $('.rlx-date').each(function () {
            if ($(this).attr('data-current-date') === date) {
              $(this).addClass('date-selected');
            } else {
              $(this).removeClass('date-selected');
            }
          });
        } else {
          $timeslotsRow.append('<li>Loading...</li>');
        }
        hideLoader();
      }, 300);
    };

    const selectCurrent = (currentDate, slotsData) => {
      showLoader();
      setTimeout(() => {
        displaySlots(currentDate, slotsData);
      }, 300);
    };

    // Disable date element if no valid timeslots
    const disableDateElement = (date) => {
      $('.rlx-date').each(function () {
        if ($(this).attr('data-current-date') === date) {
          $(this).addClass('disabled');
          $(this).removeClass('date-selected');
        }
      });
    };

    const updateWeekLabel = (startDate, endDate) => {
      const startDay = startDate.getDate();
      const startMonth = startDate.toLocaleDateString('en-GB', { month: 'long' });
      const startYear = startDate.getFullYear();
      const endDay = endDate.getDate();
      const endMonth = endDate.toLocaleDateString('en-GB', { month: 'long' });
      $('#weekLabel').text(startDay + '-' + endDay + ' ' + startMonth + ' ' + startYear);
    };

    const checkButtonState = (startDate) => {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const startOfWeek = new Date(startDate);
      const shouldDisable = startOfWeek <= now;
      const prev = $('#prevWeek');
      prev.toggleClass('disabled', shouldDisable);
      prev.prop('disabled', shouldDisable);
    };

    const updateWeek = (direction) => {
      $('#timeslots .row').empty();
      $('.timeslot-container').hide();
      currentDate.setDate(currentDate.getDate() + (direction * 7));
      const weekDates = getWeekDates(new Date(currentDate));
      preloadSlots(weekDates, currentDate);
      updateWeekLabel(weekDates[0].fullDate, weekDates[5].fullDate);
      checkButtonState(weekDates[0].fullDate);
    };

    window.initStep1 = () => {
      if (!rlxFormStep1.length) return;

      setupStep(
        rlxFormStep1,
        { appointmentPurpose: { required: true } },
        { appointmentPurpose: { required: "Your appointment purpose is required." } },
        2
      );

      const hiddenInput = document.querySelector('#appointment-purpose');
      const buttons = document.querySelectorAll('.rlx-choice');

      buttons.forEach((btn, index) => {

        btn.addEventListener('click', () => selectPurpose(btn));

        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') return;

          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPurpose(btn);
          }

          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const next = buttons[index + 1] || buttons[0];
            next.focus();
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = buttons[index - 1] || buttons[buttons.length - 1];
            prev.focus();
          }
        });
      });

      function selectPurpose(btn) {
        buttons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        hiddenInput.value = btn.dataset.value;
        rlxFormStep1.trigger('change');

        if (rlxFormStep1.valid()) {
          const formDataResult = new FormData(rlxFormStep1[0]);
          formData.data1 = formDataResult;
          btn.classList.add('disabled');

          setTimeout(() => {
            rlxStep1.hide();
            rlxStep2.show();
            window.initStep2();
          }, 200);
        }
      }
    };

    window.initStep2 = () => {
      if (rlxFormStep2.length) {
        rlxStep2.find('.rlx-back-button').on('click', function() {
          rlxStep2.hide();
          resetRadioButtons(rlxFormStep1);
          rlxStep1.show();
        });

        const appointmentPurpose = formData.data1 ? formData.data1.get('appointment-purpose') : null;

        const disclaimers = {
          "s1c07732356f55ae0d4655ec70130e11712cf7382": "Kindly note that the availability of certain Rolex watches in our boutique may be limited.",
          "sc837b3ed41696195fe9e1518f889e8f14378b1e9": "Please note that you may visit our store directly to bring/collect your watch to/from our after-sales service.",
          "d40d3cd0-1888-4936-8e14-adcf78af34c7": "Kindly note that the availability of certain Rolex watches in our Point of Sale may be limited.",
          "ad1cf6c5-8648-4f8b-abac-321dcc639336": "Kindly note that the availability of certain Rolex watches in our Point of Sale may be limited."
        };

        if (appointmentPurpose) {
          $(rlxStep2).find('.contact-content').text(disclaimers[appointmentPurpose] || "Kindly note that the availability of certain Rolex watches in our boutique may be limited.");
        }

        setupStep(rlxFormStep2, {
          availabilityAccept: { required: true }
        }, {
          availabilityAccept: { required: "You need to accept this disclaimer." }
        }, 3);

        rlxStep2.find('#gotoStep3').on('click', function () {
          const form = rlxFormStep2;

          if (form.valid()) {
              $(this).prop('disabled', true).addClass('disabled').find('span').html('Moving to next step…');
              formData.data2 = new FormData(form[0]);
              rlxStep2.hide();
              rlxStep3.show();
              initStep3();
          }
        });
      }
    };

    window.initStep3 = () => {
      if (!rlxFormStep3.length) return;

      // BACK BUTTON (existing)
      rlxStep3.find('.rlx-back-button').on('click', function() {
        rlxStep3.hide();
        resetRadioButtons(rlxFormStep2);
        resetPrevStepButton(rlxStep2, 'I understand');
        rlxStep2.show();
      });

      // Show/hide Northampton based on purpose (existing logic)
      const appointmentPurpose = formData.data1 ? formData.data1.get('appointment-purpose') : null;
      if (appointmentPurpose === "ad1cf6c5-8648-4f8b-abac-321dcc639336") {
        rlxFormStep3.find('.rlx-appointment-location[data-id="r99fa1590668599775"]').hide();
      } else {
        rlxFormStep3.find('.rlx-appointment-location[data-id="r99fa1590668599775"]').show();
      }

      // Activate validator
      setupStep(
        rlxFormStep3,
        { appointmentLocation: { required: true } },
        { appointmentLocation: { required: "You need to select a location." } },
        4
      );

      // NEW BUTTON-BASED SELECTION
      const hiddenInput = document.querySelector('#appointment-location');
      const buttons = document.querySelectorAll('.rlx-location-choice');

      buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => selectLocation(btn));

        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') return;

          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectLocation(btn);
          }

          // Optional keyboard navigation
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            (buttons[index + 1] || buttons[0]).focus();
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            (buttons[index - 1] || buttons[buttons.length - 1]).focus();
          }
        });
      });

      function selectLocation(btn) {
        buttons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        hiddenInput.value = btn.dataset.value;

        // Let the validator run
        rlxFormStep3.trigger('change');

        if (rlxFormStep3.valid()) {
          formData.data3 = new FormData(rlxFormStep3[0]);

          setTimeout(() => {
            rlxStep3.hide();
            rlxStep4.show();
            window.initStep4();
          }, 200);
        }
      }
    };


    window.initStep4 = () => {
      if (rlxFormStep4.length) {
        rlxStep4.find('.rlx-back-button').on('click', function() {
          rlxStep4.hide();
          resetRadioButtons(rlxFormStep3);
          rlxStep3.show();
        });

        const appointmentPurpose = formData.data1 ? formData.data1.get('appointment-purpose') : null;
        const appointmentLocation = formData.data3 ? formData.data3.get('appointment-location') : null;

        if (!appointmentPurpose || !appointmentLocation) {
          return;
        }

        // Validator for step 4
        const validator4 = rlxFormStep4.validate({
          rules: {
            timeslot: {
              required: true,
              timeslotAvailable: true
            }
          },
          messages: {
            timeslot: {
              required: "You need to select a timeslot."
            }
          },
          errorElement: 'div',
          errorPlacement: (error, element) => {
            error.addClass('invalid-feedback');
            $(element.parent().parent().parent()).append(error);
          },
          highlight: (element) => {
            $(element).addClass('is-invalid').removeClass('is-valid');
          },
          unhighlight: (element) => {
            $(element).addClass('is-valid').removeClass('is-invalid');
          }
        });

        const initialDates = getWeekDates(new Date(currentDate));
        updateWeekLabel(initialDates[0].fullDate, initialDates[5].fullDate);
        checkButtonState(initialDates[0].fullDate);

        refreshAccessToken(() => {
          preloadSlots(initialDates, currentDate, (slotsData) => {
            selectCurrent(formatDateToString(currentDate), slotsData);
          });
        });

        $('#nextWeek').click((e) => {
          e.preventDefault();
          if (!$(this).hasClass('disabled')) {
            updateWeek(1);
          }
        });

        $('#prevWeek').click((e) => {
          e.preventDefault();
          if (!$(this).hasClass('disabled')) {
            updateWeek(-1);
          }
        });

        $('#gotoStep5').on('click', () => {
          if (rlxFormStep4.valid()) {
            $('#gotoStep5').prop('disabled', true).addClass('disabled');
            formData.data4 = getFormData('rlx-appointment-form-4');
            const formDataResult = getFormData('rlx-appointment-form-4');

            rlxFormStep4.find('.rlx-next-step span').html('Moving to next step…');
            if (!formData.data4) return;
            setTimeout(() => {
              rlxStep4.hide();
              rlxStep5.show();
              initStep5();
            }, 300);
          }
        });
      }
    };

    window.initStep5 = () => {
      if (rlxFormStep5.length) {
        rlxStep5.find('.rlx-back-button').on('click', function() {
          rlxStep5.hide();
          resetPrevStepButton(rlxStep4, 'Next');
          rlxStep4.show();
        });

        const validator5 = validateForm(rlxFormStep5, {
          title: 'required',
          firstName: 'required',
          lastName: 'required',
          email: {
            required: true,
            email: true
          },
          phone: {
            required: true,
            phoneUK: true
          },
          trms_check: 'required'
        }, {
          title: 'Enter your title',
          firstName: 'Please enter your first name',
          lastName: 'Please enter your last name',
          email: 'Please include a valid email address',
          phone: 'Enter a valid UK phone number',
          trms_check: 'Please accept the terms and conditions'
        });

        rlxFormStep5.off('submit').on('submit', (event) => {
          event.preventDefault();

          if (submitted) {
            console.log("Submission already in progress, preventing duplicate submission.");
            return;
          }

          if (rlxFormStep5.valid()) {
            refreshAccessToken(() => {
              submitted = true;
              const submitButton = rlxFormStep5.find('.rlx-next-step');
              submitButton.prop('disabled', true).addClass('disabled').find('span').html('Booking appointment…');

              formData.data5 = getFormData('rlx-appointment-form-5');

              setTimeout(() => {
                const combinedData = new FormData();
                [formData.data1, formData.data2, formData.data3, formData.data4, formData.data5].forEach(data => {
                  for (const entry of data) {
                    combinedData.append(entry[0], entry[1]);
                  }
                });

                const appointmentPurpose = formData.data1.get('appointment-purpose');
                const appointmentLocation = formData.data3.get('appointment-location');

                const createCustomer = (callback) => {
                  const customerData = {
                    first_name: combinedData.get('firstName'),
                    last_name: combinedData.get('lastName'),
                    email_id: combinedData.get('email'),
                    phone: combinedData.get('phone')
                  };

                  $.ajax({
                    url: config.apiUrls.customerCreate,
                    type: 'POST',
                    contentType: 'application/json',
                    headers: { 'Authorization': 'Bearer ' + accessToken },
                    data: JSON.stringify(customerData),
                    success: (response) => {
                      if (typeof callback === 'function') {
                        callback(response.data.customer.key);
                      }
                    },
                    error: () => {
                      showError('Unable to create customer. Please try again later.', $('#rlx-step-5'));
                    }
                  });
                };

                const startTime = new Date(combinedData.get('timeslot'));
                const endTime = new Date(startTime.getTime() + purposeDurationMin(appointmentPurpose) * 60000);

                const formatTime = (date) => {
                  return `${date.getUTCFullYear()}-${('0' + (date.getUTCMonth() + 1)).slice(-2)}-${('0' + date.getUTCDate()).slice(-2)}T${('0' + date.getUTCHours()).slice(-2)}:${('0' + date.getUTCMinutes()).slice(-2)}Z`;
                };

                createCustomer((customerKey) => {
                  if (!customerKey) {
                    console.error("DEBUG: Customer Creation failed - No Key returned");
                    return;
                  }

                  const appointmentData = {
                    staff_key: appointmentLocation,
                    service_key: appointmentPurpose,
                    customer_key: customerKey,
                    start_time: combinedData.get('timeslot'),
                    end_time: formatTime(endTime),
                    label: "Website Rolex appointment"
                  };

                  // console.log("DEBUG: Final Appointment Payload:", appointmentData);

                  $.ajax({
                    url: config.apiUrls.appointmentCreate,
                    type: 'POST',
                    contentType: 'application/json',
                    headers: { 'Authorization': 'Bearer ' + accessToken },
                    data: JSON.stringify(appointmentData),
                    success: () => {
                      [rlxStep1, rlxStep2, rlxStep3, rlxStep4, rlxStep5].forEach(step => step.hide());

                      // Purpose label
                      $(rlxStep6).find('.rlx__appointment-detail:first .detail-content')
                        .text(purposeLabel[appointmentPurpose] || "Something went wrong. Please contact us.");

                      // Appointment time
                      const appointmentTime = combinedData.get('timeslot');
                      if (appointmentTime) {
                        const utcDate = new Date(appointmentTime);
                        const options = {
                          timeZone: 'UTC',
                          weekday: 'long',
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                          hour12: true
                        };
                        const utcFormattedTime = utcDate.toLocaleString('en-GB', options)
                          .replace(',', '').replace(':00 ', ' ');

                        $(rlxStep6).find('.rlx__appointment-detail').eq(1).find('.detail-content')
                          .text(utcFormattedTime);

                        window.appointmentInformation = `${purposeCategory(appointmentPurpose)}|${utcDate.toLocaleDateString('en-GB', { weekday: 'long' })}|${utcDate.toISOString().split('T')[0]}|${utcDate.toISOString().split('T')[1].slice(0,5)}`;
                      }

                      // Location
                      const locations = {
                        r99fa1590668599775: "1 Gold Street, Northampton, NN1 1SA",
                        r2d7a1590668443416: "78-80 High Street, Banbury, OX16 5JG"
                      };
                      $(rlxStep6).find('.rlx__appointment-detail').eq(2).find('.detail-content')
                        .text(locations[appointmentLocation] || "Something went wrong. Please contact us.");

                      rlxStep6.show();
                      _satellite.track("bookAppointment");
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({ event: 'bookAppointment' });
                    },
                    error: (xhr) => {
                      // --- ENHANCE THIS ERROR LOG ---
                      console.error("DEBUG: 400 Error Details:", xhr.responseText);
                      showError('Unable to create appointment. Error: ' + xhr.responseText, $('#rlx-step-5'));
                      submitted = false; // Reset so user can try again after fixing
                      submitButton.prop('disabled', false).removeClass('disabled').find('span').html('Retry Booking');
                    }
                  });
                });
              }, 300);
            });
          }
        });
      }
    };

    window.initStep1();
  }
})(jQuery);
